import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {BASE_TEXT} from '../../../../shared/style/typography';
import {FOCUS_BLUE} from '../../../../shared/style/colors';
import {PHONE_LANDSCAPE} from '../../../../shared/style/breakpoints';
import sanitizeData from './../../../../shared/utils/sanitize-data';

const Container = glamorous.div({
  ...BASE_TEXT,
  marginBottom: 30,
  '>div:first-child': {
    height: 'auto',
    overflow: 'auto',
    '>div.post-author': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ' > img': {
        marginRight: 8,
        borderRadius: '50%',
        width: 29,
        height: 29
      },
      '>b>a': {
        color: FOCUS_BLUE,
        textDecoration: 'underline'
      }
    },
    '>p': {
      fontSize: 14,
      lineHeight: 1.7,
      '>a': {
        color: FOCUS_BLUE,
        textDecoration: 'underline'
      },
      '>strong>a': {
        color: FOCUS_BLUE,
        textDecoration: 'underline'
      },
      [PHONE_LANDSCAPE]: {
        '>img': {
          width: 'calc(100vw - 40px)'
        }
      }
    },
    '>h1': {
      fontSize: 30,
      textAlign: 'center'
    },
    '>h2': {
      fontSize: 24,
      marginBottom: 20
    }
  }
});

const LongForm = ({content}) => {
  return (
    <Container>
      <div dangerouslySetInnerHTML={{__html: sanitizeData(content)}} />
    </Container>
  );
};

LongForm.propTypes = {
  content: PropTypes.string
};

export default LongForm;
